import { render, staticRenderFns } from "./TutorForgot1.vue?vue&type=template&id=1b88b147&"
import script from "./TutorForgot1.vue?vue&type=script&lang=js&"
export * from "./TutorForgot1.vue?vue&type=script&lang=js&"
import style0 from "./TutorForgot1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports